import { configSelector } from './redux/app/selectors.ts';
import { setStore } from './redux/store/setStore.ts';
import { store } from './redux/store.ts';
import { router } from './router.ts';
import { downloads } from './utils/downloads.ts';
import { getDefaultParam } from './utils/getDefaultParam.ts';
import { pushNotifications } from './utils/push/pushNotifications.ts';
import { radHttp } from './utils/rad-http/radHttp.ts';
import { setRouter } from './utils/router/setRouter.ts';

setStore(store);
setRouter(router);

router.resolve();

radHttp.getDefaultParam = getDefaultParam;
radHttp.defaultResponseHandler = ({ response }) => {
  if (response?.status !== 401) return;

  window.location.href = `${configSelector()?.loginUrl}?ReturnUrl=${encodeURIComponent(window.location.href)}`;
};

pushNotifications.connect();
void downloads.enable();

// Must be this style import or else getDefaultParam won't be set in time.
void import('./components/rad-app.ts');